<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import Calendar from "primevue/calendar";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
    Calendar,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      statData: [
        { type: "line", title: "Total de pagamentos", value: "-", icon: "bx-calendar-check", },
        { type: "line", title: "Valor total", value: "R$ -,--", icon: "bx-dollar-circle", },
      ],

      total: {
        value: 0,
        count: 0,
      },

      fields: [
        { key: "name", label: "Nome" },
        { key: "plan", label: "Plano" },
        { key: "value", label: "Valor" },
        { key: "date", label: "Data" },
      ],
      items: null,

      sortBy: "date_approved",
      sortDesc: true,
      currentPage: "1",
      perPage: "25",
      period: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ],
    };
  },
  methods: {
    getPayments() {
      this.items = null;

      const periodParam = this.period.length === 2
        ? this.period.map(date => date.toISOString().split("T")[0]).join(",")
        : "";

      api
        .get("subscriptions/payments", { period: periodParam })
        .then((response) => {
          if (response.data.status == "success") {
            this.total = response.data.total;
            this.items = response.data.list;

            this.statData = [
              { type: "line", title: "Total de pagamentos", value: this.total.count.toString(), icon: "bx-calendar-check", },
              { type: "line", title: "Valor total", value: this.$options.filters.currency(this.total.value).toString(), icon: "bx-dollar-circle", },
            ];
          } else {
            this.total = { value: 0, count: 0 };
            this.items = [];
          }
        })
        .catch((error) => {
          if (error) {
            this.total = { value: 0, count: 0 };
            this.items = [];
          }
        });
    },
  },
  mounted() {
    this.getPayments();
  },
  watch: {
    period(dates) {
      this.period = dates;
      if (dates[0] && dates[1]) {
        this.getPayments();
      }
    },
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Assinaturas</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Pagamentos de assinaturas</h3>
        <p>Pagamentos realizados no período</p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-6 col-lg-4 col-xl-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light" class="period" ref="period">
        <template #button-content>
          período
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <Calendar v-model="period" inline selectionMode="range" dateFormat="dd/mm/yy" :manualInput="false" hide-header></Calendar>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          por página
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
    </div>

    <div v-if="!items" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div class="card" v-else-if="items && items.length == 0">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum pagamento encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :current-page="currentPage" :per-page="perPage" responsive>
            <template #cell(value)="row">
              {{ row.item.value | currency }}
            </template>
            <template #cell(type)="row">
              <span class="badge badge-status bg-soft-info" v-if="row.item.type == 'pix'">PIX</span>
              <span class="badge badge-status bg-soft-info" v-else-if="row.item.type == 'creditcard'">Cartão</span>
              <span class="badge badge-status bg-soft-secondary" v-else>{{ row.item.type }}</span>
            </template>
            <template #cell(date_approved)="row">
              {{ row.item.date_approved }}
            </template>
          </b-table>
        </div>

        <b-pagination class="mt-3" v-model="currentPage" :total-rows="total.count" :per-page="perPage" pills align="center"></b-pagination>
      </div>
    </div>
  </Layout>
</template>
